import walletFinancialPositionsMessages from '../../../../messages/wallet/wallet-financial-positions.messages';
import { Column } from '../../../column';
import { UnitLinkedAtPriceProduct } from '../../financial-insurance-macro-category';

export const mobileUnitLinkedAtPriceColumns: Column<UnitLinkedAtPriceProduct>[] =
  [
    {
      headerLabel: walletFinancialPositionsMessages.tableHeaderProduct,
      key: 'productName',
      type: 'string',
    },
    {
      headerLabel:
        walletFinancialPositionsMessages.tableHeaderCounterValueShort,
      key: 'equivalent',
      type: 'amount',
    },
  ];
